import React from 'react';
import StartButton from './StartButton';
import type { InterestId } from '@/content/workflows';

interface PageHeroProps {
  eyebrow: string;
  title: React.ReactNode;
  children: React.ReactNode;
  note?: React.ReactNode;
  interest?: InterestId;
  showCta?: boolean;
}

const PageHero = ({ eyebrow, title, children, note, interest, showCta = true }: PageHeroProps) => (
  <section className="relative overflow-hidden">
    <div className="reveal relative mx-auto max-w-7xl px-4 pb-20 pt-16 sm:px-6 md:pb-24 md:pt-24">
      <p className="eyebrow">{eyebrow}</p>
      <h1 className="mt-5 max-w-5xl text-[clamp(3rem,6.4vw,5.75rem)] leading-none">{title}</h1>
      <div className="mt-7 max-w-[35rem] text-[1.19rem] leading-relaxed text-mist">{children}</div>
      {showCta && (
        <div className="mt-10 flex flex-col gap-5 sm:flex-row sm:items-center">
          <StartButton size="lg" interest={interest} />
          {note && <p className="max-w-sm text-sm text-mist">{note}</p>}
        </div>
      )}
    </div>
  </section>
);

export default PageHero;
